// extracted by mini-css-extract-plugin
module.exports = {"textareaContainer":"CommentComposer_textareaContainer__bQDyj","textarea":"CommentComposer_textarea__QfM04","rightAdornment":"CommentComposer_rightAdornment__eIhqz"};